/* eslint-disable jira/naming/disallow-filenames */

import React from 'react';
import type CustomFieldDetail from '@jira/spa-apps__admin-pages-performance-metric-detail-custom-field/src/CustomFieldDetail.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyCustomFieldDetail: LazyComponent<() => React.JSX.Element> = lazyForPaint<
	typeof CustomFieldDetail
>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-system-performance-metric-detail", jiraSpaEntry: "async-system-performance-custom-field" */ '@jira/spa-apps__admin-pages-performance-metric-detail-custom-field/src/CustomFieldDetail.tsx'
		),
	),
);

export const CustomFieldMetricDetail = (): React.JSX.Element => (
	<LazyPage
		Page={LazyCustomFieldDetail}
		pageId="system-performance-metric-detail-custom-field"
		shouldShowSpinner
	/>
);
